// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-detail {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.order-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.order-detail-grid .detail-row {
  display: grid;
  grid-template-columns: 130px 1fr;
  align-items: center;
  gap: 0.75rem;
  padding: 0.8rem 1rem;
  background: #fff;
  border: none;
  border-bottom: 1px solid #f1f3f5;
  border-radius: 0;
  box-shadow: none;
  transition: background-color 0.15s ease;
}

.order-detail-grid .detail-row.detail-row-full {
  grid-column: 1 / -1;
  grid-template-columns: 130px 1fr;
  border-right: none;
}

.order-detail-grid .detail-row.detail-row-full > :last-child {
  white-space: pre-wrap;
  word-break: break-word;
}

.order-detail-grid .detail-row:hover {
  background: #f8fafc;
}

.order-detail-grid .detail-row .detail-label {
  color: #475467;
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.order-detail-grid .detail-row > :last-child {
  justify-self: start;
  text-align: left;
  color: #1d2939;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  width: 100%;
}

.order-detail-grid .detail-row > :last-child .text-muted {
  color: #667085 !important;
  font-weight: 500;
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.detail-section > strong {
  font-size: 0.75rem;
  font-weight: 700;
  color: #475467;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding-bottom: 0.4rem;
  border-bottom: 2px solid #00b4f3;
  align-self: flex-start;
}

.detail-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 1.1rem;
  background: #fff;
  border: 1px solid #e9ecef;
  border-top: 2px solid #00b4f3;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.detail-total > :first-child {
  font-size: 0.75rem;
  color: #475467;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.detail-totals {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.85rem 1.1rem;
  background: #fff;
  border: 1px solid #e9ecef;
  border-top: 2px solid #00b4f3;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.detail-totals-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  color: #475467;
  font-weight: 500;
}

.detail-totals-row > :last-child {
  font-weight: 600;
  color: #1d2939;
  white-space: nowrap;
}

.detail-totals-row.detail-totals-grand {
  margin-top: 0.35rem;
  padding-top: 0.65rem;
  border-top: 1px solid #e9ecef;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1d2939;
  text-transform: none;
}

.detail-totals-row.detail-totals-grand > :last-child {
  font-size: 1.15rem;
  font-weight: 700;
}

.detail-sale-link {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e9ecef;
  border-left: 3px solid #10b981;
  border-radius: 6px;
  padding: 0.7rem 0.9rem;
  font-size: 0.875rem;
}

.order-detail-modal-icon-box {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #00b4f3 0%, #006c80 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
}

.order-status-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.order-sale-nav-link {
  display: inline-block;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #00b4f3;
  text-decoration: none;
  cursor: pointer;
  line-height: 1.3;
}

.order-sale-nav-link:hover {
  color: #006c80;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .order-detail-grid {
    grid-template-columns: 1fr;
  }
  .order-detail-grid .detail-row {
    grid-template-columns: 120px 1fr;
    border-right: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/approvals/plugins/order/orderDetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,MAAM;EACN,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;IAChC,6BAA6B;EAC/B;AACF","sourcesContent":[".order-detail {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.order-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.order-detail-grid .detail-row {\n  display: grid;\n  grid-template-columns: 130px 1fr;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.8rem 1rem;\n  background: #fff;\n  border: none;\n  border-bottom: 1px solid #f1f3f5;\n  border-radius: 0;\n  box-shadow: none;\n  transition: background-color 0.15s ease;\n}\n\n.order-detail-grid .detail-row.detail-row-full {\n  grid-column: 1 / -1;\n  grid-template-columns: 130px 1fr;\n  border-right: none;\n}\n\n.order-detail-grid .detail-row.detail-row-full > :last-child {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.order-detail-grid .detail-row:hover {\n  background: #f8fafc;\n}\n\n.order-detail-grid .detail-row .detail-label {\n  color: #475467;\n  font-weight: 700;\n  font-size: 0.72rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.order-detail-grid .detail-row > :last-child {\n  justify-self: start;\n  text-align: left;\n  color: #1d2939;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  width: 100%;\n}\n\n.order-detail-grid .detail-row > :last-child .text-muted {\n  color: #667085 !important;\n  font-weight: 500;\n}\n\n.detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.detail-section > strong {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #475467;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding-bottom: 0.4rem;\n  border-bottom: 2px solid #00b4f3;\n  align-self: flex-start;\n}\n\n.detail-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.85rem 1.1rem;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-top: 2px solid #00b4f3;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.detail-total > :first-child {\n  font-size: 0.75rem;\n  color: #475467;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.detail-totals {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding: 0.85rem 1.1rem;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-top: 2px solid #00b4f3;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.detail-totals-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  font-size: 0.875rem;\n  color: #475467;\n  font-weight: 500;\n}\n\n.detail-totals-row > :last-child {\n  font-weight: 600;\n  color: #1d2939;\n  white-space: nowrap;\n}\n\n.detail-totals-row.detail-totals-grand {\n  margin-top: 0.35rem;\n  padding-top: 0.65rem;\n  border-top: 1px solid #e9ecef;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1d2939;\n  text-transform: none;\n}\n\n.detail-totals-row.detail-totals-grand > :last-child {\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.detail-sale-link {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e9ecef;\n  border-left: 3px solid #10b981;\n  border-radius: 6px;\n  padding: 0.7rem 0.9rem;\n  font-size: 0.875rem;\n}\n\n.order-detail-modal-icon-box {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #00b4f3 0%, #006c80 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 18px;\n}\n\n.order-status-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.35rem;\n}\n\n.order-sale-nav-link {\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #00b4f3;\n  text-decoration: none;\n  cursor: pointer;\n  line-height: 1.3;\n}\n\n.order-sale-nav-link:hover {\n  color: #006c80;\n  text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n  .order-detail-grid {\n    grid-template-columns: 1fr;\n  }\n  .order-detail-grid .detail-row {\n    grid-template-columns: 120px 1fr;\n    border-right: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
